import { render, staticRenderFns } from "./stepFive.vue?vue&type=template&id=2b073316&scoped=true"
import script from "./stepFive.vue?vue&type=script&lang=js"
export * from "./stepFive.vue?vue&type=script&lang=js"
import style0 from "./stepFive.vue?vue&type=style&index=0&id=2b073316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b073316",
  null
  
)

export default component.exports